module.exports = __webpack_public_path__ + "img/rule1.273c6c71.jpg";